import { useEffect, useState } from 'react';
import { surMajDisponible, appliquerMaj } from '../pwa/sw.js';
import { Bouton } from './base.jsx';

/**
 * La bannière de reprise.
 *
 * Sur une application installée il n'y a plus de barre d'adresse : c'est la seule
 * porte de sortie vers une nouvelle version. Elle ne s'ouvre JAMAIS pendant un match —
 * un rechargement au milieu d'un chrono est le genre de chose qu'on ne pardonne pas.
 */
export function BanniereMaj({ matchEnCours }) {
  const [dispo, setDispo] = useState(false);
  useEffect(() => surMajDisponible(setDispo), []);

  if (!dispo || matchEnCours) return null;

  return (
    <div role="status" style={{
      position: 'absolute', left: 12, right: 12, zIndex: 50,
      // Au-dessus de la barre d'onglets, hors du tiers du pouce : recharger est une
      // action perturbante, pas un geste réflexe.
      bottom: 'calc(env(safe-area-inset-bottom) + 72px)',
      display: 'flex', alignItems: 'center', gap: 12, padding: '11px 12px 11px 16px',
      background: 'var(--surf2)', border: '1px solid var(--line)', borderRadius: 15,
      boxShadow: 'var(--ombre)',
    }}>
      <span style={{ flex: 1, fontSize: 13.5 }}>Nouvelle version prête.</span>
      <Bouton ton="principal" taille={40} onClick={appliquerMaj}>Reprendre</Bouton>
    </div>
  );
}
